<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Available clients</h3>
        <v-spacer/>
        <v-btn color="success" @click="handleClickCreateClientButton">Create client</v-btn>
      </v-card-title>
      <v-card-text>
        <table class="v-table table-striped theme--light">
          <thead>
            <tr>
              <th class="column text-xs-left">Title</th>
              <th class="column text-xs-left">Email addresses (comma separated)</th>
              <th class="column text-xs-left">Invite to dp cases emails (comma separated)</th>
              <th class="column text-xs-left">Case originator</th>
              <th class="column text-xs-left">Originator client ids</th>
              <th class="column text-xs-left">Report send mode</th>
              <th class="column text-xs-left">Allow hide header</th>
              <th class="column text-xs-left">No UNIM stamp</th>
              <th class="column text-xs-left">Exclude from statistic</th>
              <th class="column text-xs-left">Cost center</th>
              <th class="column text-xs-left">Region</th>
              <th class="column text-xs-left">Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <client-item v-for="client in items"
                        v-bind:key="client.id"
                        v-bind:item="client"
                        :caseOriginators="caseOriginators"
                        :caseOriginatorsById="caseOriginatorsById"
                        :availableReportSendModesByValue="availableReportSendModesByValue"
                        :availableReportSendModes="availableReportSendModes"
                        @deleted="handleClientDeletedEvent"
                        @editClient="handleClientEditEvent"
                        @click="handleClientClickEvent">
            </client-item>
          </tbody>
        </table>

        <v-flex d-block xs6>
          <client-creation-form :visible="createClientFormVisible"
                                :caseOriginators="caseOriginators"
                                :availableReportSendModes="availableReportSendModes"
                                :selectedClientItem="selectedClientItem"
                                :availableContractors="availableContractors"
                                @created="handleCreationFormCreatedEvent"
                                @updated="handleClientUpdatedEvent"
                                @close="handleCreationFormCloseEvent"></client-creation-form>
        </v-flex>
      </v-card-text>
    </v-card>
    <v-layout row justify-center v-if="editedClient !== null">
      <v-dialog v-model="editClientVisible" persistent lazy no-click-animation fullscreen>
        <client-details :edited-client="editedClient"
                      :clientServices="clientServicesByClientId[editedClient.id] || []"
                      :servicesById="servicesById"
                      :availableSpecialistRole="availableSpecialistRole"
                      @close="closeEditClientWindow"
                      @clientSpecialistCreated="handleClientSpecialistCreated"
                      @clientSpecialistUpdated="handleClientSpecialistUpdated"
                      @clientSpecialistDeleted="handleClientSpecialistDeleted"
                      @clientServiceUpdated="handleClientServiceUpdated"
                      @clientServiceDeleted="handleClientServiceDeleted"></client-details>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import ClientCreationForm from './ClientCreationForm'
import ClientItem from './ClientItem'
import ClientDetails from './ClientDetails'
import _ from 'lodash'

export default {
  name: 'clients',
  components: {
    ClientCreationForm,
    ClientItem,
    ClientDetails
  },
  props: {
    items: {
      type: Array
    },
    caseOriginators: {
      type: Array
    },
    caseOriginatorsById: {
      type: Object
    },
    clientServicesByClientId: {
      type: Object
    },
    servicesById: {
      type: Object
    },
    availableReportSendModes: {
      type: Array
    },
    availableSpecialistRole: {
      type: Array
    },
    availableContractors: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      editClientVisible: false,
      createClientFormVisible: false,
      editedClient: null,
      selectedClientItem: null
    }
  },
  computed: {
    availableReportSendModesByValue () {
      return _.keyBy(this.availableReportSendModes, 'value')
    }
  },
  methods: {
    handleClickCreateClientButton () {
      this.selectedClientItem = null
      this.createClientFormVisible = !this.createClientFormVisible
    },
    handleCreationFormCreatedEvent () {
      this.createClientFormVisible = false
      this.$emit('clientCreated')
    },
    handleCreationFormCloseEvent () {
      this.createClientFormVisible = false
    },
    handleClientUpdatedEvent (updatedClient) {
      this.createClientFormVisible = !this.createClientFormVisible
      this.$emit('clientUpdated', updatedClient)
    },
    handleClientEditEvent (item) {
      this.createClientFormVisible = !this.createClientFormVisible
      this.selectedClientItem = item
    },
    handleClientDeletedEvent (deletedClient) {
      this.$emit('clientDeleted', deletedClient)
    },
    handleClientClickEvent (client) {
      this.editedClient = client
      this.editClientVisible = true
    },
    closeEditClientWindow () {
      this.editedClient = null
      this.editClientVisible = false
    },
    handleClientSpecialistCreated (specialist) {
      this.$emit('clientSpecialistCreated', specialist)
    },
    handleClientSpecialistUpdated (specialist) {
      this.$emit('clientSpecialistUpdated', specialist)
    },
    handleClientSpecialistDeleted (specialist) {
      this.$emit('clientSpecialistDeleted', specialist)
    },
    handleClientServiceUpdated (clientService) {
      this.$emit('clientServiceUpdated', clientService)
    },
    handleClientServiceDeleted (clientService) {
      this.$emit('clientServiceDeleted', clientService)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Clients.vue